import { createAction } from '@reduxjs/toolkit'

const getComplianceOverview = createAction('compliance/getComplianceOverview')

export const complianceActions = {
  getComplianceOverview,
}
